import { get, post, del, put } from '../utility/http';

export async function fetchWarningList(
  { ctx,
    startDate, stopDate, cleaned,
    taskId, jobId, alsoPilots, username,
    download }
    : {
      ctx: string,
      startDate?: string, stopDate?: string, cleaned?: boolean,
      taskId?: string, jobId?: string, alsoPilots?: string,
      username?: string,
      download?: string
    }
) {
  try {

    //console.log(`${startDate} - ${stopDate} - ${cleaned}`);
    let queryString = '';
    if (startDate) {
      queryString = `?startTime=${startDate}`;
    }
    if (stopDate) {
      queryString = `${queryString}${queryString.length == 0 ? '?' : '&'}stopTime=${stopDate}`;
    }
    if (cleaned != undefined) {
      queryString = `${queryString}${queryString.length == 0 ? '?' : '&'}cleaned=${cleaned}`;
    }
    if (taskId != undefined) {
      queryString = `${queryString}${queryString.length == 0 ? '?' : '&'}taskId=${taskId}`;
    }
    if (jobId != undefined) {
      queryString = `${queryString}${queryString.length == 0 ? '?' : '&'}jobId=${jobId}`;
    }
    if (alsoPilots != undefined) {
      queryString = `${queryString}${queryString.length == 0 ? '?' : '&'}alsoPilots=${alsoPilots}`;
    }
    if (username != undefined) {
      queryString = `${queryString}${queryString.length == 0 ? '?' : '&'}username=${username}`;
    }


     
    const url =  `/warnings/ctx/${ctx}${download?'/export':''}${queryString}`;
    //console.log('url', url);
    const response: any = await get(url,
      true, {}, false, true
    );


    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function AddWarning(body: any) {
  try {
    const response = await post(
      '/warnings',
      true,
      {},
      body
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
} 


export async function DeleteWarning(id: string) {
  try {
    const response = await del(
      `/warnings/${id}`,
      true 
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
} 

export async function AcknoledgeWarning(row: any) {
  try {
    const response = await put(
      `/warnings/${row.id}`,
      true ,
      {},
      {...row, cleaned: true}
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
} 


